// constants

// action_component_subject
const SET_LOADING_PAGE = "SET_LOADING_PAGE";

// reducers

const initialState = false;

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_LOADING_PAGE:
			return action.payload;

		default:
			return state;
	}
};

export default Reducer;

// actions

// const resolveAfter2Seconds = () => {
// 	return new Promise((resolve) => {
// 		setTimeout(() => {
// 			resolve("resolved");
// 		}, 2000);
// 	});
// };

// // action_component_subject
// export const decrementTestCounter = () => async (dispatch) => {
// 	const result = await resolveAfter2Seconds();
// 	console.log(result);
// 	dispatch({
// 		type: INCREMENT_TEST_COUNTER,
// 	});
// };

// action_component_subject, prefix set(not update),empty(not remove),hide,show
export const setLoadingPage = (payload) => {
	return {
		type: SET_LOADING_PAGE,
		payload: payload,
	};
};
